import { FC } from 'react';
import { useFormContext } from 'react-hook-form';
import { FormControlLabel, TextField } from '@mui/material';

interface DataUploaderControllerProps {
  index: number;
}

const DataUploaderNetworkIdController: FC<DataUploaderControllerProps> = ({ index }) => {
  const { register, watch } = useFormContext();
  const fieldValues = watch('data_uploaders_network_ids') ?? [];

  return (
    <FormControlLabel
      label="DATA UPLOADERS NETWORK ID"
      control={
        <TextField
          disabled
          data-testid={`data_uploaders_network_id.${fieldValues[index]}`}
          {...register(`data_uploaders_network_ids.${index}`)}
        />
      }
    />
  );
};

export default DataUploaderNetworkIdController;
